import {useState} from 'react'
import Modal from '@/components/Modal/Modal.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'

const bodyStyle = {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    gap: 8,
}

export default function ModalChooseDesignItems({
    fetch,
    getQuery = a => a,
    multiple = true,
    FormChoose,
    TableChoose,
    onOk,
    ...props
}) {
    const map = useMapContext()
    const {prjId, sVer} = map.data

    const defaultQuery = {
        prjId,
        sortMode: 'UPT_TIME',
        sVer,
    }

    const [query, setQuery] = useState(defaultQuery)
    const [selectedItems, setSelectedItems] = useState([])
    const _getQuery = values => ({...defaultQuery, ...getQuery(values)})
    const onSelect = item => onOk([item])
    const _onOk = () => onOk(selectedItems)

    return (
        <Modal
            bodyStyle={bodyStyle}
            closable={false}
            maskClosable={false}
            onOk={_onOk}
            {...props}
        >
            <FormChoose
                getQuery={_getQuery}
                onFinish={setQuery}
            />

            <TableChoose
                fetch={fetch}
                multiple={multiple}
                query={query}
                selectRowOnClick
                onChange={setSelectedItems}
                onSelect={onSelect}
            />
        </Modal>
    )
}
